export default "__VITE_ASSET__BkBa3fC1__"